'use strict';

import moment from 'moment';

const zeroDuration = '00:00:00';
const undefinedDateTime = '0001-01-01T00:00:00.000+00:00';

/**
 * EcsAgentStatsMath
 **/
export default class EcsAgentStatsMath {
  static calcOnlineTime(agentStats, onlineTime = 0, verbose = false, numeric = false) {
    // const onlineStateStats = [
    //   (agentStats.agentTotalReadyTime || {}).value || zeroDuration,
    //   (agentStats.agentTotalBusyTime || {}).value || zeroDuration,
    //   (agentStats.agentTotalDialingTime || {}).value || zeroDuration,
    //   (agentStats.agentBreakTime || {}).value || zeroDuration,
    //   (agentStats.agentTotalNoAnswerTime || {}).value || zeroDuration,
    //   (agentStats.agentBackOfficeTime || {}).value || zeroDuration,
    //   (agentStats.agentTotalHandlingOutgoingTime || {}).value || zeroDuration
    // ];
    const onlineStateStats = [(agentStats.agentLoginTimeSpan || {}).value || zeroDuration];

    return EcsAgentStatsMath._calcTotalDuration(onlineStateStats, onlineTime, verbose, numeric);
  }

  static calcReadyTime(agentStats, readyTime = 0, verbose = false, numeric = false) {
    const readyStateStats = [(agentStats.agentTotalReadyTime || {}).value || zeroDuration];
    return EcsAgentStatsMath._calcTotalDuration(readyStateStats, readyTime, verbose, numeric);
  }

  static calcBusyTime(agentStats, busyTime = 0, verbose = false, numeric = false) {
    const busyStateStats = [
      (agentStats.agentTotalBusyTime || {}).value || zeroDuration,
      (agentStats.agentTotalDialingTime || {}).value || zeroDuration
    ];
    return EcsAgentStatsMath._calcTotalDuration(busyStateStats, busyTime, verbose, numeric);
  }

  static calcBreakTime(agentStats, breakTime = 0, verbose = false, numeric = false) {
    const breakStateStats = [
      (agentStats.agentBreakTime || {}).value || zeroDuration,
      (agentStats.agentTotalNoAnswerTime || {}).value || zeroDuration
    ];
    return EcsAgentStatsMath._calcTotalDuration(breakStateStats, breakTime, verbose, numeric);
  }

  static calcNoAnswerTime(agentStats, breakTime = 0, verbose = false) {
    const breakStateStats = [
      (agentStats.agentBreakTime || {}).value || zeroDuration,
      (agentStats.agentTotalNoAnswerTime || {}).value || zeroDuration
    ];
    return EcsAgentStatsMath._calcTotalDuration(breakStateStats, breakTime, verbose);
  }

  static calcBackofficeTime(agentStats, backofficeTime = 0, verbose = false, numeric = false) {
    const backofficeStats = [(agentStats.agentBackOfficeTime || {}).value || zeroDuration];
    return EcsAgentStatsMath._calcTotalDuration(backofficeStats, backofficeTime, verbose, numeric);
  }

  static calcOutgoingTime(agentStats, outgoingTime = 0, verbose = false, numeric = false) {
    const outgoingStats = [(agentStats.agentTotalHandlingOutgoingTime || {}).value || zeroDuration];
    return EcsAgentStatsMath._calcTotalDuration(outgoingStats, outgoingTime, verbose, numeric);
  }

  static agentTimingSecs(agentStats) {
    return {
      readyTime: {
        value: EcsAgentStatsMath.calcReadyTime(agentStats, 0, false, true),
        duration: EcsAgentStatsMath.calcReadyTime(agentStats, 0, true)
      },
      busyTime: {
        value: EcsAgentStatsMath.calcBusyTime(agentStats, 0, false, true),
        duration: EcsAgentStatsMath.calcBusyTime(agentStats, 0, true)
      },
      breakTime: {
        value: EcsAgentStatsMath.calcBreakTime(agentStats, 0, false, true),
        duration: EcsAgentStatsMath.calcBreakTime(agentStats, 0, true)
      },
      backofficeTime: {
        value: EcsAgentStatsMath.calcBackofficeTime(agentStats, 0, false, true),
        duration: EcsAgentStatsMath.calcBackofficeTime(agentStats, 0, true)
      },
      outgoingTime: {
        value: EcsAgentStatsMath.calcOutgoingTime(agentStats, 0, false, true),
        duration: EcsAgentStatsMath.calcOutgoingTime(agentStats, 0, true)
      },
      loginTimeSpan: {
        value: EcsAgentStatsMath.calcOnlineTime(agentStats, 0, false, true),
        duration: EcsAgentStatsMath.calcOnlineTime(agentStats, 0, true)
      }
    };
  }

  static stringifyDuration(duration, verbose, short, numeric) {
    const hh = duration.get('hours');
    const mm = duration.get('minutes');
    const ss = duration.get('seconds');

    if (verbose) {
      const hhVerbose = hh ? `${hh}h` : '';
      const mmVerbose = mm ? `${mm}m` : '';
      const ssVerbose = `${ss || '0'}s`;
      return `${hhVerbose} ${mmVerbose} ${ssVerbose}`;
    }

    if (numeric) {
      return ss + mm * 60 + hh * 3600;
    }

    const HH = hh.toString().padStart(2, '0');
    const MM = mm.toString().padStart(2, '0');
    const SS = ss.toString().padStart(2, '0');

    const hhShort = hh ? `${HH}:` : ``;
    const mmShort = `${short && !hh ? mm : MM}:${SS}`;

    return short ? `${hhShort}${mmShort}` : `${HH}:${MM}:${SS}`;
  }

  static sumDurations(durations) {
    const duration = moment.duration({ seconds: 0, minutes: 0, hours: 0 });
    durations.forEach(time => duration.add(moment.duration(time)));
    return duration;
  }

  static _getDurationDiffSince(strDate) {
    if (strDate === undefinedDateTime) {
      return zeroDuration;
    }
    const duration = moment.duration(moment().diff(moment(strDate)));
    return EcsAgentStatsMath.stringifyDuration(duration);
  }

  static _calcTotalDuration(stateStats, additionalTime, verbose, numeric) {
    const duration = EcsAgentStatsMath.sumDurations(stateStats);
    if (additionalTime >= 0) {
      duration.add(additionalTime, 'seconds');
    } else {
      duration.subtract(-additionalTime, 'seconds');
    }
    return EcsAgentStatsMath.stringifyDuration(duration, verbose, false, numeric);
  }
}
